import type { FunctionComponent } from "react";

export type HowItWorksStep = { title: string; description: string };

export type HowItWorksSectionProps = {
  title: string;
  steps: HowItWorksStep[];
  image?: { src: string; alt: string };
  note?: string;
};

export const HowItWorksSection: FunctionComponent<HowItWorksSectionProps> = ({
  title,
  steps,
  image,
  note,
}) => (
  <section className="container px-5 my-12">
    <h2 className="font-serif text-3xl font-bold mb-8">{title}</h2>
    <div className="md:grid md:grid-cols-2 md:gap-10 items-start">
      <ol className="flex flex-col gap-6">
        {steps.map((step, index) => (
          <li key={step.title} className="flex gap-4">
            <span
              className="flex-none w-9 h-9 flex items-center justify-center rounded-md text-white font-bold"
              style={{
                backgroundColor: "var(--color-primary)",
                border: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            >
              {index + 1}
            </span>
            <div>
              <h3 className="font-bold mb-1">{step.title}</h3>
              <p className="text-neutral-600">{step.description}</p>
            </div>
          </li>
        ))}
      </ol>
      {image && (
        <div className="mt-8 md:mt-0">
          <img src={image.src} alt={image.alt} className="w-full h-auto" loading="lazy" />
        </div>
      )}
    </div>
    {note && <p className="text-xs text-neutral-400 mt-4">{note}</p>}
  </section>
);
